"use strict";

import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import BaseControl from "D5Utils/form_fields/BaseControl";

var BoolControl =
/*#__PURE__*/
function (_BaseControl) {
  _inherits(BoolControl, _BaseControl);

  function BoolControl(props) {
    var _this;

    _classCallCheck(this, BoolControl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BoolControl).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "allowNullState", true);

    if (_this.props.allowNullState != null) {
      _this.allowNullState = _this.props.allowNullState;
    }

    if (!_this.allowNullState && _this.value == null) {
      _this.value = false;
    }

    return _this;
  }

  _createClass(BoolControl, [{
    key: "_buildControlProps",
    value: function _buildControlProps() {
      var _this2 = this;

      return {
        value: this.value != null ? this.value : undefined,
        onValueChanged: function onValueChanged(e) {
          if (_this2.allowNullState) {
            if (e.component.skipOnValueChanged) {
              e.component.skipOnValueChanged = false;
              return;
            }

            if (e.component.setUndefinedNextTime) {
              e.component.setUndefinedNextTime = false;
              e.component.skipOnValueChanged = true;
              e.component.option("value", undefined);

              if (typeof _this2.props.onValueChanged === 'function') {
                _this2.props.onValueChanged({
                  value: undefined
                });
              }

              return;
            }

            if (e.value == false) {
              e.component.setUndefinedNextTime = true;
            }
          }

          if (typeof _this2.props.onValueChanged === 'function') {
            _this2.props.onValueChanged(e);
          }
        }
      };
    }
  }, {
    key: "instance",
    value: function instance() {
      return this.$_element.dxCheckBox('instance');
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.instance().dispose();
      this.$_element.remove();
    }
  }, {
    key: "render",
    value: function render() {
      this.$_element = this.$_element.dxCheckBox(_objectSpread({}, this._buildControlProps()));
    }
  }]);

  return BoolControl;
}(BaseControl);

export { BoolControl as default };